export default "__VITE_ASSET__BcJx7Z96__"